<nb-card class="card-scroll">
	<nb-card-header class="card-header-title">
		<div class="card-header-title">
			<ngx-back-navigation></ngx-back-navigation>
			<h4>
				{{
					'PROPOSALS_PAGE.PROPOSAL_DETAILS.PROPOSAL_DETAILS'
						| translate
				}}
			</h4>
		</div>
		<div>
			<button nbButton (click)="edit()" status="info" class="mr-2">
				<nb-icon class="mr-1" icon="edit-outline"></nb-icon
				>{{ 'PROPOSALS_PAGE.PROPOSAL_DETAILS.EDIT' | translate }}
			</button>
		</div>
	</nb-card-header>

	<nb-card-body class="card-container">
		<div class="wrapper-top">
			<nb-card class="prop-card">
				<h6>
					{{ 'PROPOSALS_PAGE.PROPOSAL_DETAILS.AUTHOR' | translate }}
				</h6>
				<p>{{ author }}</p>
			</nb-card>
			<nb-card class="prop-card">
				<h6>
					{{
						'PROPOSALS_PAGE.PROPOSAL_DETAILS.JOB_POST_URL'
							| translate
					}}
				</h6>
				<a *ngIf="jobPostLink" href="jobPostLink" target="_blank">{{
					'PROPOSALS_PAGE.PROPOSAL_DETAILS.VIEW_JOB_POST' | translate
				}}</a>
			</nb-card>
			<nb-card class="prop-card">
				<h6>
					{{
						'PROPOSALS_PAGE.PROPOSAL_DETAILS.PROPOSAL_SENT_ON'
							| translate
					}}
				</h6>
				{{ proposal?.valueDate | date: 'shortDate' }}
			</nb-card>
			<nb-card class="prop-card">
				<h6>
					{{ 'PROPOSALS_PAGE.PROPOSAL_DETAILS.STATUS' | translate }}
				</h6>
				<ga-propsal-status
					*ngIf="proposal"
					[rowData]="proposal"
				></ga-propsal-status>
			</nb-card>
		</div>
		<div class="wrapper-bottom">
			<nb-card class="prop-card">
				<h6>
					{{
						'PROPOSALS_PAGE.PROPOSAL_DETAILS.JOB_POST_CONTENT'
							| translate
					}}
				</h6>
				<div class="px-5" [innerHTML]="jobPostContent"></div>
				<div class="tags px-5">
					<nb-badge
						*ngFor="let tag of proposal?.tags"
						class="color"
						position="centered"
						[style.background]="tag.color"
						text="{{ tag.name }}"
					>
					</nb-badge>
				</div>
			</nb-card>
			<nb-card class="prop-card">
				<h6>
					{{
						'PROPOSALS_PAGE.PROPOSAL_DETAILS.PROPOSAL_CONTENT'
							| translate
					}}
				</h6>
				<div class="px-5" [innerHTML]="proposalContent"></div>
			</nb-card>
		</div>
	</nb-card-body>
</nb-card>
